import { render, staticRenderFns } from "./Accesibility.vue?vue&type=template&id=2b5d21a4&scoped=true&"
import script from "./Accesibility.vue?vue&type=script&lang=js&"
export * from "./Accesibility.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b5d21a4",
  null
  
)

export default component.exports